(() => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const INITIALIZATION_ATTRIBUTE = 'data-featured-brands';

  function initializeAllFeaturedBrandSliders() {
    const sliderElements = document.querySelectorAll(`[${INITIALIZATION_ATTRIBUTE}]`);
    sliderElements.forEach((sliderElement) => initializeFeaturedBrandSlider(sliderElement));
  }

  function initializeFeaturedBrandSlider(sliderElement) {
    const wrapperElement = sliderElement.closest('.featured-brand-slider__wrapper') || sliderElement.parentElement;

    const navigationNextElement = wrapperElement?.querySelector('.swiper-button-next') || null;
    const navigationPrevElement = wrapperElement?.querySelector('.swiper-button-prev') || null;
    const paginationElement = wrapperElement?.querySelector('.swiper-pagination') || null;

    let swiperInstance = null;

    const resolveSlidesPerView = (viewportWidth) => {
      if (viewportWidth >= 1440) return 6; // Large desktop
      if (viewportWidth >= 1200) return 5; // ≥1200px
      if (viewportWidth >= 1024) return 4; // ≥1024px
      return 1; // Won't be used when disabled for mobile
    };

    const shouldDisableForMobile = (viewportWidth) => viewportWidth < 768; // Disable slider on mobile

    const createSwiper = (slidesPerView) => new Swiper(sliderElement, {
      slidesPerView,
      watchOverflow: true,
      loop: true,
      allowTouchMove: true,
      keyboard: { enabled: true },
      navigation: navigationNextElement && navigationPrevElement ? {
        nextEl: navigationNextElement,
        prevEl: navigationPrevElement,
      } : undefined,
      pagination: paginationElement ? {
        el: paginationElement,
        clickable: true,
      } : undefined,
    });

    const teardownSwiper = () => {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    };

    const configureSwiper = () => {
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

      if (shouldDisableForMobile(viewportWidth)) {
        teardownSwiper();
        return;
      }

      const desiredSlidesPerView = resolveSlidesPerView(viewportWidth);

      if (!swiperInstance) {
        swiperInstance = createSwiper(desiredSlidesPerView);
        return;
      }

      if (swiperInstance.params.slidesPerView !== desiredSlidesPerView) {
        swiperInstance.params.slidesPerView = desiredSlidesPerView;
        swiperInstance.update();
      }
    };

    let resizeDebounceTimer = null;
    const onResize = () => {
      clearTimeout(resizeDebounceTimer);
      resizeDebounceTimer = setTimeout(configureSwiper, 150);
    };

    configureSwiper();
    window.addEventListener('resize', onResize);

    // Handle Theme Editor lifecycle
    document.addEventListener('shopify:section:unload', (event) => {
      if (event && event.target && event.target.contains(sliderElement)) {
        teardownSwiper();
        window.removeEventListener('resize', onResize);
      }
    });

    document.addEventListener('shopify:section:load', (event) => {
      if (event && event.target && event.target.contains(sliderElement)) {
        configureSwiper();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllFeaturedBrandSliders);
  } else {
    initializeAllFeaturedBrandSliders();
  }
})();


